import primaryComponents from "../../../../primaryComponents";
import styles from "./styles.module.scss";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { PlusCircle } from "../../../../../assets/svgIcons";
import { useDispatch } from "react-redux";
import secondaryComponents from "../../..";
import { useEffect, useMemo, useState } from "react";
import { CreditDetails } from "../CreditPayment/CreditDetailsForm";
import { WalletDetailsForm } from "../StoreWalletPayment/WalletDetailsForm";
import {
  formatCurrency,
  setToDateMonthYearInWords,
  truncateString,
} from "../../../../../helpers";
import { setApiErrorMessage } from "../../../../../store/modules/apiErrorHandler";
import EditIconV2 from "../../../../../assets/svgIcons/EditIconV2";
import { useCart } from "../../../../../hooks/useCart";
import { useCheckoutHelper } from "../../../../../hooks/useCheckoutHelper";
import { useParams } from "react-router-dom";
import { useGetOrderDetails } from "../../../../../hooks/api/queries/useOrder";
import { LedgerForm } from "../../LedgerForm";

export const SplitPayment = ({
  storeDetails: propStoreDetails,
  isRequired = false,
  errorMessage,
}) => {
  const dispatch = useDispatch();
  const params = useParams();
  const {
    payment,
    customer,
    store_wallet,
    updatePayment: setPaymentAmount,
    setStoreWallet,
  } = useCheckoutHelper();
  const { totalCalculatedPrice, storeDetails } = useCart({});
  const activeStoreDetails = propStoreDetails || storeDetails;
  const { data: orderDetails } = useGetOrderDetails({
    id: params?.order_id,
    isEnabled: true,
  });
  const [views, setViews] = useState({
    isCredit: false,
    isStoreWallet: false,
  });
  const totalCalculatedAmount =
    totalCalculatedPrice || orderDetails?.total_amount || 0;

  const balance = useMemo(() => {
    return (
      Number(totalCalculatedAmount) -
      (Number(payment?.pay_with_split?.cash_amount || 0) +
        Number(payment?.pay_with_split?.card_amount || 0) +
        Number(payment?.pay_with_split?.transfer_amount || 0) +
        Number(payment?.pay_with_split?.credit_amount || 0) +
        Number(payment?.pay_with_split?.store_wallet_amount || 0) +
        Number(payment?.pay_with_split?.pr_amount || 0))
    );
  }, [orderDetails, payment?.pay_with_split]);

  useEffect(() => {
    setStoreWallet(null);
  }, []);

  const updatePayment = (key, value) => {
    setPaymentAmount({
      key: "pay_with_split",
      [key]: value,
    });
  };

  return (
    <>
      <section>
        <div className="d-flex justify-content-between mb-1">
          <h5 className="mb-0">Split Payment</h5>
          <p className="font-weight-semibold">
            Balance:{" "}
            <span
              className={`${balance === 0 ? "success--text" : "error--text"}`}
            >
              {formatCurrency({
                value: balance,
                currencyCode: storeDetails?.currency_code,
              })}
            </span>
          </p>
        </div>

        <div className={styles.gridView}>
          <primaryComponents.InputField
            placeholder={"Enter amount"}
            classNames="white"
            sideLabelInputText={"Cash"}
            floatError={false}
            type="number"
            value={payment?.pay_with_split?.cash_amount || ""}
            onChange={({ target: { value } }) => {
              updatePayment("cash_amount", value);
            }}
          />

          <primaryComponents.InputField
            placeholder={"Enter amount"}
            classNames="white"
            sideLabelInputText={"Card"}
            floatError={false}
            type="number"
            value={payment?.pay_with_split?.card_amount || ""}
            onChange={({ target: { value } }) => {
              updatePayment("card_amount", value);
            }}
          />

          <primaryComponents.InputField
            placeholder={"Enter amount"}
            classNames="white"
            sideLabelInputText={"Transfer"}
            floatError={false}
            type="number"
            value={payment?.pay_with_split?.transfer_amount || ""}
            onChange={({ target: { value } }) => {
              updatePayment("transfer_amount", value);
            }}
          />

          <primaryComponents.InputField
            placeholder={"Enter amount"}
            classNames="white"
            sideLabelInputText={"PR"}
            floatError={false}
            type="number"
            value={payment?.pay_with_split?.pr_amount || ""}
            onChange={({ target: { value } }) => {
              updatePayment("pr_amount", value);
            }}
          />

          <div>
            <primaryComponents.InputField
              placeholder={"Enter amount"}
              classNames="white"
              sideLabelInputText={"Store Wallet"}
              floatError={false}
              type="number"
              isDisabled={store_wallet?.session_id}
              value={payment?.pay_with_split?.store_wallet_amount || ""}
              onChange={({ target: { value } }) => {
                updatePayment("store_wallet_amount", value);
              }}
            />
            {payment?.pay_with_split?.store_wallet_amount ? (
              <div className={`${globalStyles.cardWithBorder} ${styles.card}`}>
                {!store_wallet ? (
                  <primaryComponents.Button
                    onClick={() => {
                      if (!payment?.pay_with_split?.store_wallet_amount)
                        return dispatch(
                          setApiErrorMessage({
                            message: "Please enter store wallet amount",
                          }),
                        );

                      setViews((prev) => ({ ...prev, isStoreWallet: true }));
                    }}
                    classNames={"mx-auto btn btn--outline smallBtn"}
                    style={{ borderRadius: "15px" }}
                  >
                    <span className="mr-2">Select Wallet</span> <PlusCircle />
                  </primaryComponents.Button>
                ) : null}

                {store_wallet ? (
                  <div className="d-flex ">
                    <span className="d-flex align-items-center">
                      <span className="small-text-size dark--text font-weight-semibold">
                        {formatCurrency({
                          value: store_wallet?.balance,
                          currencyCode: store_wallet?.currency_code,
                        })}
                      </span>
                      <span className="mx-1">-</span>
                      <span className="smallest-text-size dark--text font-weight-semibold mr-4">
                        <span className="gray--text">
                          <span className="orange--text">
                            ({store_wallet?.tag})
                          </span>
                        </span>
                      </span>
                    </span>

                    {customer ? (
                      <span
                        className="ml-auto cursor-pointer"
                        onClick={() =>
                          setViews((prev) => ({ ...prev, isStoreWallet: true }))
                        }
                      >
                        <EditIconV2
                          className={"font-weight-normal"}
                          color="#7647ee"
                        />
                      </span>
                    ) : null}
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>

          <div>
            <primaryComponents.InputField
              placeholder={"Enter amount"}
              classNames="white"
              sideLabelInputText={"Credit"}
              floatError={false}
              type="number"
              value={payment?.pay_with_split?.credit_amount || ""}
              onChange={({ target: { value } }) => {
                updatePayment("credit_amount", value);
              }}
            />
            {payment?.pay_with_split?.credit_amount ? (
              <div className={`${globalStyles.cardWithBorder} ${styles.card}`}>
                {!customer ? (
                  <primaryComponents.Button
                    onClick={() =>
                      setViews((prev) => ({ ...prev, isCredit: true }))
                    }
                    classNames={"mx-auto btn btn--outline smallBtn"}
                    style={{ borderRadius: "15px" }}
                  >
                    <span className="mr-2">
                      {customer ? "Change" : "Add"} Customer
                    </span>{" "}
                    <PlusCircle />
                  </primaryComponents.Button>
                ) : null}
                <div className="d-flex ">
                  {payment?.pay_with_split?.repayment_date || customer ? (
                    <p className="smallext-text-size">
                      <span className="small-text-size font-weight-semibold dark--text">
                        {truncateString(customer?.customerName || "", 25)}
                      </span>
                      <br />
                      <span className="gray--text small-text-size">
                        {payment?.pay_with_split?.repayment_date
                          ? setToDateMonthYearInWords(
                              payment?.pay_with_split?.repayment_date,
                            )
                          : ""}
                      </span>
                    </p>
                  ) : null}

                  {customer ? (
                    <span
                      className="ml-auto cursor-pointer"
                      onClick={() =>
                        setViews((prev) => ({ ...prev, isCredit: true }))
                      }
                    >
                      <EditIconV2
                        className={"font-weight-normal"}
                        color="#7647ee"
                      />
                    </span>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        </div>

        {activeStoreDetails?.allow_chart_account_selection_on_checkout ? (
          <div className="mt-3">
            <LedgerForm isRequired={isRequired} errorMessage={errorMessage} />
          </div>
        ) : null}
      </section>

      <secondaryComponents.Modal width={550} isActive={views?.isCredit}>
        <CreditDetails
          closeModal={() => setViews((prev) => ({ ...prev, isCredit: false }))}
          updatePayment={updatePayment}
        />
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        width={550}
        isActive={views?.isStoreWallet}
        closeModal={() => {
          if (store_wallet && store_wallet?.session_id)
            return setViews((prev) => ({ ...prev, isStoreWallet: false }));

          setStoreWallet(null);
          setViews((prev) => ({ ...prev, isStoreWallet: false }));
        }}
      >
        <WalletDetailsForm
          amount={payment?.pay_with_split?.store_wallet_amount}
          setStoreWallet={setStoreWallet}
          closeModal={() => {
            setViews((prev) => ({ ...prev, isStoreWallet: false }));
          }}
        />
      </secondaryComponents.Modal>
    </>
  );
};
